import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  dialogContentClassName: {
    padding: ({ is_desktop }) => (is_desktop ? "24px 0" : "16px 0"),
  },
  modalPaperClassName: {
    position: "static",
    minWidth: "680px",
  },
  footerClassName: {
    zIndex: 7,
  },
}));
